import { render } from "./AllLabs.vue?vue&type=template&id=4ca3e3cd&scoped=true"
import script from "./AllLabs.vue?vue&type=script&lang=js"
export * from "./AllLabs.vue?vue&type=script&lang=js"

import "./AllLabs.vue?vue&type=style&index=0&id=4ca3e3cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca3e3cd"]])

export default __exports__